module.exports = __webpack_public_path__ + "static/img/twjd-sdm1.0ef3a39.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdm1.png
// module id = 851
// module chunks = 0